<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UFKVXN/tc-custom/9781780109008.jpg?1705548929967" alt="This image is the cover for the book Smoke and Mirrors, The Miss Barnum Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Smoke and Mirrors, The Miss Barnum Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Phineas T. Barnum’s sister must solve a murder in 19th-century New York City in this historical mystery from the author of the Pepper Martin mysteries.</b></p><p>Evie Barnum oversees her brother’s American Museum, a place teeming with scientific specimens and “human prodigies” including a bearded woman and the lizard man. In this weird and whacky workplace, Evie hopes she can easily bury her secrets.<br/><br/> But when an old friend shows up and begs for her help, she does all she can to stay away. The next time she sees him, he is dead in front of the exhibit of the Feejee Mermaid. Suspicion for the murder falls on Jeffrey, known as the Lizard Man, but Evie knows it isn’t possible.<br/><br/> After Jeffrey disappears, Evie becomes determined to solve the mystery of her friend’s murder, even if it brings her face to face with a past she is desperate to hide…</p><p><b>“[An] appealing heroine…. Amusing and eye-opening historical details complement a mystery that’s appropriately melodramatic.”—<i>Publishers Weekly</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Casey Daniels
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22c7bd90